
	import {Options, Vue} from "vue-property-decorator";
	import TelehealthHeader from "@/components/telehealth/TelehealthHeader.vue";

	@Options({components: {TelehealthHeader}})
	export default class PatientTelehealthHeader extends Vue
	{
	}

